module.exports = __webpack_public_path__ + "img/search.fdec6351.svg";